// container/winners/winners.tsx
import { t } from 'i18next';
import React from 'react';
import styled from 'styled-components';
import { TextElem } from '../../../../common/text';
import { SIZE_FONT_ENUM } from '../../../../theme/size';
import { MamaTextLogo } from '../../container/home/frame/hero';

interface WeekItem {
    labelTid: string;
    href?: string;
}

const WEEK_ITEMS: WeekItem[] = [
    { labelTid: 'MAMA.WINNER.WEEK_1', href: t('MAMA.WINNER.WEEK_1_HREF') },
    { labelTid: 'MAMA.WINNER.WEEK_2', href: t('MAMA.WINNER.WEEK_2_HREF') },
    { labelTid: 'MAMA.WINNER.WEEK_3', href: t('MAMA.WINNER.WEEK_3_HREF') },
    { labelTid: 'MAMA.WINNER.WEEK_4', href: t('MAMA.WINNER.WEEK_4_HREF') },
    { labelTid: 'MAMA.WINNER.WEEK_5', href: t('MAMA.WINNER.WEEK_5_HREF') },
];

export const Winners: React.FC = () => {
    return (
        <Container id="winners">
            <MamaTextLogo
                color="white"
                size={SIZE_FONT_ENUM.TITLE_LARGE}
                type="extra-bold"
                tid="MAMA.WINNER.COMPETITION_WINNERS"
            />
            <WeekList>
                {WEEK_ITEMS.map((item, index) => (
                    <WeekItemWrapper
                        key={index}
                        as={item.href ? 'a' : 'div'}
                        href={item.href}
                        $hasLink={!!item.href}
                    >
                        <TextElem tid={item.labelTid} type="regular" />
                    </WeekItemWrapper>
                ))}
            </WeekList>
        </Container>
    );
};

const Container = styled.div`
  max-width: 1400px;
  width: 100%;
  position: relative;
  z-index: 2;
  margin-bottom: 100px;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 10px;
  margin: auto;
`;

const WeekList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 544px;
`;

const WeekItemWrapper = styled.div<{ $hasLink: boolean }>`
  background: linear-gradient(180deg, #FFCD00 48.89%, #F2740C 100%);
  box-shadow: 6px 10px 0px 0px #00000026;
  border-radius: 12px;
  width: 100%;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: ${({ $hasLink }) => ($hasLink ? 'pointer' : 'default')};
    opacity: ${({ $hasLink }) => ($hasLink ? 1 : 0.5)};

  ${({ $hasLink }) => $hasLink && `
    &:hover { filter: brightness(1.07); }
  `}
`;